angular.module('Itao.IndicatorMap').directive('districtKeyRadios', ['mapConfig', 'communeConfig', function (mapConfig, communeConfig) {
  'use strict';

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'districtKeyRadios.html',
    scope: {
      districts: '=',
      selectedDistrictKey: '='
    },
    link: function (scope) {
      scope.disabledDistrictKeys = scope.disabledDistrictKeys || [];
      jQuery('#districtToggle').click(function(){
        jQuery(this).closest('.district-container').toggleClass('open');
      });
    }
  };
}]);
